const PullDown = () => {
  const pullDownFstBox = document.querySelector('.richNightCare__exp--01');
  const pullDownSecBox = document.querySelector('.richNightCare__exp--02');
  const pullDownFst = document.querySelector('.detailFst');
  const pullDownSec = document.querySelector('.detailSec');
  const ttlFstBox = pullDownFstBox.querySelector('.richNightCare__exp--ttl');
  const ttlSecBox = pullDownSecBox.querySelector('.richNightCare__exp--ttl');
  const btnFstImg = pullDownFstBox.querySelector('.richNightCare__exp--btnImg');
  const btnSecImg = pullDownSecBox.querySelector('.richNightCare__exp--btnImg');

  const btns = document.querySelectorAll('.richNightCare__exp--btn');
  const fstBtn = document.querySelector('.btn-fst');
  const secBtn = document.querySelector('.btn-sec');

  fstBtn.addEventListener('click', () => {
    if (!pullDownFst.classList.contains('addHeight')) {
      pullDownFst.classList.add('addHeight');
      ttlFstBox.style.borderBottom = '0.1rem solid #fff';
      btnFstImg.classList.add('arrowRotate');
    } else {
      pullDownFst.classList.remove('addHeight');
      btnFstImg.classList.remove('arrowRotate');
      setTimeout(() => {
        ttlFstBox.style.borderBottom = 'none';
      }, 300);
    }
  });
  secBtn.addEventListener('click', () => {
    if (!pullDownSec.classList.contains('addHeight')) {
      pullDownSec.classList.add('addHeight');
      ttlSecBox.style.borderBottom = '0.1rem solid #fff';
      btnSecImg.classList.add('arrowRotate');
    } else {
      pullDownSec.classList.remove('addHeight');
      btnSecImg.classList.remove('arrowRotate');
      setTimeout(() => {
        ttlSecBox.style.borderBottom = 'none';
      }, 300);
    }
  });
};

export default PullDown;
